import { Col, Row } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import OrderContext from "../../../context/order/context";
import {
    getOrderRate,
    getOrderStatus,
} from "../../../models/order/enum";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { useLocation } from "react-router-dom";

interface IProps { }

const OrderRatedFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(OrderContext);

  const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});
  
    useEffect(() => {
      const filters = getFiltersFromURL();
  
      const initialValuesObj = {};
      filters.forEach((f) => {
        initialValuesObj[f.name] = f.value;
      });
  
      setInitialValues(initialValuesObj);
    }, [location.search]);

  const status = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  const rated = [1, 2, 3, 4, 5];

  return (
    <Form
      formId="order-rated-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
              data?.rating
                  ? {
                      name: "rating",
                      value: data.rating,
                      operation: "eq",
                  }
                  : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: status.map((status, index) => {
                return {
                  label: t(getOrderStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
          <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
              <FieldBuilder
                  name="rating"
                  label={`${t("rated")}`}
                  width="large"
                  input={{
                      type: "select",
                      allowSearch: true,
                      options: rated.map((rate, index) => {
                          return {
                              label: t(getOrderRate(rate) as string),
                              value: rate as number,
                          };
                      }),
                  }}
              />

          </Col>
      </Row>
    </Form>
  );
};

export default OrderRatedFilter;
